import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOffersData } from '../../actions/offersData';
import { Footer } from '../../components/Footer';
import { Pagination } from '../../components/Pagination';
import { NEWBUILDINGS_GK_SUGGEST_COUNT } from '../../constants/config';
import { TTypedThunkDispatch } from '../../types/thunk';
import { PrintButtonContainer } from '../PrintButton';
import { selectTotal } from '../../selectors/offersData';
import { incrementAnimationCounter } from '../../actions/consultantCianChat';
import { usePagination } from '../../hooks/pagination';
import { IPaginationOnClickParams } from '../../types/pagination';

export const OffersFooterContainer: React.FC = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const total = useSelector(selectTotal) || 0;
  const maxPage = Math.ceil(total / NEWBUILDINGS_GK_SUGGEST_COUNT);
  const shouldShowPagination = Boolean(maxPage && maxPage > 1);

  const { pages, nextPage, prevPage } = usePagination();

  const onClick = React.useCallback(
    ({ page, url }: IPaginationOnClickParams) => {
      dispatch(getOffersData({ page, path: url, reason: 'pagination' }));
      dispatch(incrementAnimationCounter());
    },
    [dispatch],
  );

  return (
    <Footer
      pagination={
        shouldShowPagination && <Pagination onClick={onClick} pages={pages} nextPage={nextPage} prevPage={prevPage} />
      }
      printButton={<PrintButtonContainer />}
    />
  );
};
